import { useMapRasterLayer } from "./useMapRasterLayer"
import { useReportOverlayStatus } from "./useReportOverlayStatus"
import { BASEMAP_RASTER_LAYER_IDS, overlaysBelow } from "./layerOrder"

export const GIBS_IMPERVIOUS =
    "https://gibs.earthdata.nasa.gov/wmts/epsg3857/best/Landsat_Global_Man-made_Impervious_Surface/default/GoogleMapsCompatible_Level12/{z}/{y}/{x}.jpg"

const ABOVE = [...BASEMAP_RASTER_LAYER_IDS, ...overlaysBelow("civilization")]

export function useCivilizationLayer(enabled: boolean) {
    const status = useMapRasterLayer(enabled, "civilization", GIBS_IMPERVIOUS, {
        maxzoom: 12,
        opacity: 0.6,
        persistSource: true,
        above: ABOVE,
    })
    useReportOverlayStatus("civilization", status)
}
